var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMajesticonsSearchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 20.0004L15.9504 15.9504M15.9504 15.9504C16.6004 15.3003 17.116 14.5286 17.4678 13.6793C17.8196 12.83 18.0007 11.9197 18.0007 11.0004C18.0007 10.0811 17.8196 9.17076 17.4678 8.32144C17.116 7.47211 16.6004 6.7004 15.9504 6.05036C15.3003 5.40031 14.5286 4.88467 13.6793 4.53287C12.83 4.18107 11.9197 4 11.0004 4C10.0811 4 9.17076 4.18107 8.32144 4.53287C7.47211 4.88467 6.7004 5.40031 6.05036 6.05036C4.73754 7.36318 4 9.14375 4 11.0004C4 12.857 4.73754 14.6375 6.05036 15.9504C7.36318 17.2632 9.14375 18.0007 11.0004 18.0007C12.857 18.0007 14.6375 17.2632 15.9504 15.9504Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsSearchLine);
export default __webpack_public_path__ + "static/media/majesticons_search-line.db203ca53a8188145c419392fa8c3418.svg";
export { ForwardRef as ReactComponent };